module.exports = __webpack_public_path__ + "static/media/nextIcon.d29356a2.svg";